//BB: action for get course list (DashBoard)
//http://127.0.0.1:8000/analytics/dashboard/teacher/get-all-course-list/?teacher_id=123456&time_period=custom&start_date=2024-11-08&end_date=2025-01-20
//http://127.0.0.1:8000/analytics/dashboard/teacher/get-all-course-list/?teacher_id=123456&time_period=month&start_date=Nov-2024
//http://127.0.0.1:8000/analytics/dashboard/teacher/get-all-course-list/?teacher_id=123456&time_period=week&start_date=Nov-2024
//http://127.0.0.1:8000/analytics/dashboard/teacher/get-all-course-list/?teacher_id=123456&time_period=yearly&start_date=2024
// Note: Dates are sent in YYYY-MM-DD format for custom period only

import { Dispatch } from "redux";
import api from "../../api/api";
import {
    setCourseList,
    setLoading,
    // seterror,
    // setPagination,
    resetCourseList,
} from "../reducers/getAllCourseListByTeacherReducer";

const getAllCourseListByTeacher = (
    teacher_id: any,
    token: any,
    time_period?: string,
    start_date?: string,
    end_date?: string
  ) => async (dispatch: Dispatch) => {
    dispatch(setLoading(true));
    try {
      const params: any = {
        //we have to send teacher id in params
        teacher_id: teacher_id,
      };
  
      // Add time_period, start_date, and end_date if provided
      if (time_period) {
        params.time_period = time_period;
      }
      if (start_date) {
        params.start_date = start_date;
      }
      if (end_date) {
        params.end_date = end_date;
      }
  
      const result = await api.get(
        `/analytics/dashboard/teacher/get-all-course-list/`,
        {
          params: params,
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization:` Token ${token}`,
          },
        }
      );
  
      if (result) {
        dispatch(setCourseList({
            courses: result.data.courses,
            department_role_data: result.data.department_role_data
        }));
  
        //dispatch(setloading(false));
        if (result.data?.status === 200) {
          //dispatch(setCourseList(result.data.data));
          //dispatch(setPagination(result.data));
        } else {
          //dispatch(seterror(result.data?.message ?? "Something Went Wrong!"));
        }
      }
    } catch (error) {
      dispatch(setLoading(false));
      console.error("Error fetching course list:", error);
    }
  };
  
  //export { getAllCoursesByTeacherId, resetCourseList };
  export { getAllCourseListByTeacher, resetCourseList };


